export default __webpack_public_path__ + "static/media/mastercard.6df11f1a.svg";